import React from 'react'
import {withTranslation} from 'react-i18next';
import Parent from '../../../common/parent';
import './tables.css';
import {BllinkLogger} from '../../../common/utils/bllink_loggers';
import $ from 'jquery';
import { constants } from '../../../common/constants/constants';
import { i18n } from '../../../common/translations';
import deleteCheckRowIcon from "../../../images/new-dlt.png";
import Select from 'react-select';
import {selectCustomStyles} from '../../../common/shared/select.styled';
import {NotificationManager} from "react-notifications";


class SingleMonthTable extends Parent {

    constructor(props) {
        super(props);
        BllinkLogger.info(`SingleMonthTable props`, props);
        // this.state = {
        //     buildingID: props.buildingID
        // }

        this.onScriptLoad.bind(this);
    }

    async componentDidMount() {
        this.colorRefundsInRed();
        this.bindLinks();
        this.bindTooltips();
        await this.addHiddenBuildingTitle();
        this.enableSortTable();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.colorRefundsInRed();
        this.bindLinks();
        this.bindTooltips();

    }

    onScriptLoad() {

        let tableFound = false

        function initTableSort() {
            setTimeout(function () {
                tableFound = window.$("table").length;
                if (!tableFound) {
                    BllinkLogger.info('table still not found ')
                    initTableSort();         //  ..  again which will trigger another
                } else {
                    window.$("table").stupidtable({
                        'numberWithCommas': function (a, b) {
                            return parseFloat(a.replace(/[ ,]/g, "")) - parseFloat(b.replace(/[ ,]/g, ""));
                        },
                        'date': function (a, b) {
                            return b.date - a.date
                        }
                    });
                }
            }, 1000)
        }

        initTableSort()

    }

    enableSortTable() {
        setTimeout(() => {
            if (!window.$().stupidtable) {
                this.loadScript(
                    `https://cdnjs.cloudflare.com/ajax/libs/stupidtable/1.1.3/stupidtable.min.js`,
                    this.onScriptLoad
                )
            } else {
                this.onScriptLoad()
            }
        }, 1000)
    }

    renderAmount(amountData) {
        return amountData.value
    }

    expensesTypes(expensesTypes, index) {
        const value = expensesTypes.expenseTypeID.value ? expensesTypes.expenseTypeID : expensesTypes.all[0];
        return (
            <Select
                id={`expense-type-${index}`}
                className={'js-expense-type'}
                styles={selectCustomStyles}
                options={expensesTypes.all || []}
                value={value}
                menuPortalTarget={document.querySelector('body')}
                onChange={val => this.props.onChangeExpenseType(val, index)}
            />
        )
    }

    expenseDescription(description, index) {
        let hasValue = !Array.isArray(description);
        let indexId = `expense-description-${index}`;
        let className = 'js-expense-description form-control no-border';
        let placeHolder = hasValue ? description : i18n.t('expenses.description_placeholder');
        return (
            <input type="text"
                   id={indexId}
                   className={className}
                   placeholder={placeHolder}/>
        )

    }

    expensesIndex(itemData, index) {
        return index
    }

    expenseAmount(itemAmount, index) {
        return (<input type="text"
                       id={`expense-amount-${index}`}
                       name={`expense-amount-${index}`}
                       className={"js-expense-amount form-control no-border"}
                       defaultValue={itemAmount} placeholder={'0'}/>)
    }

    expenseActions(actions, index) {
        const deleteIcon = index > 1 ? <img alt="delete-row" src={deleteCheckRowIcon}/> : '';
        return (<div>
            <div className="js-remove-expense-row" id={`expense-remove-${index}`}>
                {deleteIcon}
            </div>
        </div>)
    }

    parseExpenseFrequency(isRecurring) {
        return isRecurring === 'yes' ? i18n.t('expenses.recurring') : i18n.t('expenses.one_time')
    }


    renderIsActive(isActive, index, extraData) {
        // todo make this clickable for admins only
        const text = isActive === 'yes' ? i18n.t('payment_settings.active') : i18n.t('payment_settings.inactive');
        const action = isActive !== 'yes' ? 'unfreeze': 'freeze';
        const thisObj = this;
        return <div className='link' onDoubleClick={async () => {
            thisObj.startLoader();
            BllinkLogger.info(`freeze-unfreeze-one-time clicked ${action}`);
            const apartmentNumber = extraData.apartmentName;
            const url = `/managers/one-time-payment-settings/${thisObj.props.tableState.buildingID}/${thisObj.props.tableState.oneTimeSettingsID}/${apartmentNumber}?action=${action}`
            const result = await thisObj.client.post(url);
            BllinkLogger.info(`result freeze/unfreeze is `, result);
            const isSuccess = Array.isArray(result) && result.length > 0;
            if (isSuccess) {
                NotificationManager.success(
                    i18n.t('statuses.success_action_notification')
                )
            }else {
                NotificationManager.error(
                    i18n.t('statuses.error_action_notification')
                )
            }
            window.location.reload();
        }}
        >
            {text}
        </div>



    }

    renderExpenseType(expenseTypeKey) {
        return i18n.t(`expenses.expenseTypes.${expenseTypeKey}`);
    }

    colorRefundsInRed() {
        const allNegativeAmounts = $('td.is-negative-amount');
        const allNegativeAmounts2 = $('tr.red-row');
        const redColorClass = 'negative-amount-row';
        // first removing all red rows
        $('table > tbody > tr').removeClass(redColorClass);
        // now re coloring negative amounts
        allNegativeAmounts.parent('tr').addClass(redColorClass);
        allNegativeAmounts2.addClass(redColorClass);
    }

    bindLinks() {
        const thisObj = this;
        setTimeout(() => {
            const allDownloadLinks = $('.js-downloaded-link');
            const allConfirmationLinks = $('.js-confirmation-link');
            const numberOfDownloadLinks = allDownloadLinks.length
            const numberOfConfirmationLinks = allConfirmationLinks.length
            BllinkLogger.info(`numberOfConfirmationLinks ${numberOfConfirmationLinks} numberOfDownloadLinks ${numberOfDownloadLinks}`)

            allDownloadLinks.unbind('click').bind('click', async (e) => {
                await this.handleTablesLinksClicked(thisObj, e)
            })

            allConfirmationLinks.unbind('click').bind('click', async (e) => {
                await this.handleTablesLinksClicked(thisObj, e)
            })
        }, 500)
    }

    async handleTablesLinksClicked(thisObj, e) {
        e.preventDefault();

        thisObj.startLoader();
        const response = await thisObj.client.get($(e.target).attr('href'));
        thisObj.endLoader();
        if (response) {
            console.log(`response is`, response);
            let win = window.open(response, '_blank');
            win.focus();
        }
    }

    getItem(row, fieldData, index, extraData) {
        let item;
        if (typeof fieldData === 'string') {
            item = row[fieldData]
        } else {
            if (row[fieldData.fieldName]) {
                item = this[fieldData.functionName](row[fieldData.fieldName], index, extraData)
            } else if (fieldData.functionName2) {
                item = this[fieldData.functionName2](row[fieldData.fieldName2], index, extraData)
            } else if (fieldData.fieldNames) {
                let args = fieldData.fieldNames.map(fieldName => {
                    return row[fieldName]
                })
                item = this[fieldData.functionName](...args)
            }
        }

        return item
    }

    getExtraData(row, fieldData) {
        let extraData;
        if (typeof fieldData !== 'string' && fieldData.extraData) {
            extraData = extraData || {};
            const fieldName = fieldData.extraData.fieldName;
            extraData[fieldName] = row[fieldData.extraData.fieldName];
        }

        return extraData
    }

    getItemClasses(itemText) {
        let className = 'js-payment-item ';
        if (this.JsExtras.isNumeric(itemText)) {
            className = this.addNumberClassNames(className, itemText);
        } else if ($.type(itemText) === 'object') {
            className = this.addNumberClassNames(className, itemText.props.exceltext);
        }

        return className
    }

    addNumberClassNames(className, itemText) {
        if (this.JsExtras.isNumeric(itemText)) {
            className += 'is-amount '
            if (parseInt(itemText) < 0) {
                className += ' is-negative-amount'
            }
        }

        return className

    }

    colorRowInRed(paymentState) {
        return (constants.APIContract.paymentStates.CANCELED_PAYMENT_STATUSES.includes(paymentState))
    }

    renderConfirmationID(confirmationID, invoiceDownloadLink) {
        let result = invoiceDownloadLink
        if (confirmationID) {
            result += ` (${i18n.t('reports.cheque_confirmation_id', {confirmationID: confirmationID})})`
        }

        return result
    }

    rowClasses(row, rowLevelConditions) {
        let result = ''
        for (const condition of rowLevelConditions) {
            if (this[condition.functionName](row[condition.fieldName])) {
                result += ' ' + condition.classes
            }
        }

        return result
    }

    render() {
        const {t} = this.props;
        BllinkLogger.info(`single month tables is `, this.props);
        const subTitle = this.props.subTitle ? this.props.subTitle : '';
        // let tableWidth = this.props.columns ? `col-md-${this.props.columns}` : "col-md-12";
        const isTableEmpty = (!this.props.rows || this.props.rows.length === 0)
        if (isTableEmpty) {
            return <div className="ensure-height">
                <h2 className="text-center">
                    {t('reports.empty_table_for', {name: this.props.title})}
                </h2>
            </div>
        }

        return (
            <section>
                <div className="ensure-height">
                    <div key={Math.floor(Math.random() * 1000)} id="table_structure">
                        <div className="table-title">
                            <h4 className="js-table-title" tablename={this.props.tableType}>{this.props.title}</h4>
                            <h3 className={'js-subtitle'}>{subTitle}</h3>
                            <span className={'hidden-except-print js-building-print-title'}/>
                        </div>
                        <table className={`table months-cashflow ${this.props.tableType} tableFixHead table-fit`}
                               data-excel-title={this.props.excelReportTitle}
                               key={Math.floor(Math.random() * 100)}
                               id="table">
                            <thead id="table-id">
                            <tr>
                                {this.props.headerNames.map((headerData, index) => {
                                    if ($.type(headerData) === 'object') {
                                        // todo make this clickable
                                        return <th scope="col" className={"clickable table-header"} data-sort={headerData.dataType}
                                                   key={index}>{headerData.name}</th>
                                    } else {
                                        return <th scope="col" className={"table-header"} key={index}>{headerData}</th>
                                    }

                                })}
                            </tr>
                            </thead>
                            <tbody>
                                {this.props.rows.map((row, rowIndex) => {
                                    // BllinkLogger.info(`row is ${rowIndex}`, row)
                                    let extraRowClasses = this.props.rowLevelConditions ? this.rowClasses(row, this.props.rowLevelConditions) : '';
                                    // BllinkLogger.info(`extraRowClasses are `, extraRowClasses)
                                    return (
                                        <tr className={extraRowClasses} key={rowIndex}>
                                            {this.props.fields.map((fieldData, index)=>{
                                                let extraData = this.getExtraData(row, fieldData, rowIndex+1);
                                                let item = this.getItem(row, fieldData, rowIndex+1, extraData);

                                                let className, dataToggle = '', dataHtml = '', toolTipTitle = '';
                                                const shouldRenderWithToolTip = ($.type(item) === 'object' && item.originalComment);
                                                if(shouldRenderWithToolTip) {
                                                    BllinkLogger.info(`tooltip item`, item)
                                                    dataToggle = 'tooltip'; dataHtml = 'true';
                                                    toolTipTitle = item.originalComment;
                                                    item = <span exceltext={item.originalComment}>{item.shortComment}</span>
                                                }

                                                className = this.getItemClasses(item);
                                                return <td
                                                    key={index}
                                                    className={className}
                                                    data-toggle={dataToggle}
                                                    data-placement="top"
                                                    data-html={dataHtml}
                                                    title={toolTipTitle}
                                                >
                                                    {item}
                                                </td>
                                            })}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        )
    }
}


export default withTranslation()(SingleMonthTable)
